export default "__VITE_ASSET__C1ESH1a6__"